import { defineMessages } from 'react-intl';

export const scope = 'app.components.ManagePlayersPage';

// Copy for the welcome-email send. {noun} is filled by the pluralize helper so the
// count word agrees without ICU plural syntax.
export const messages = defineMessages({
  snackWelcomeSent: {
    id: `${scope}.snackWelcomeSent`,
    defaultMessage: 'Welcome emails sent.',
  },
  errWelcomeInProgress: {
    id: `${scope}.errWelcomeInProgress`,
    defaultMessage: 'Welcome emails are already being sent for this association. Wait for that to finish, then try again.',
  },
  // The send refuses unless every age group in the filter is still reachable, and names
  // how many it rejected — the names are gone with the age groups, so the count carries it.
  errWelcomeInaccessibleAgeGroups: {
    id: `${scope}.errWelcomeInaccessibleAgeGroups`,
    defaultMessage: 'Nothing was sent: {names} in your filter {verb} no longer available to you. Update the age group filter and try again.',
  },
  errWelcomeFailed: {
    id: `${scope}.errWelcomeFailed`,
    defaultMessage: "Couldn't send the welcome emails. Please try again.",
  },
});
